<template>
  <el-dialog
    v-model="dialogVisible"
    title="市场咨询海报"
    width="980px"
    center
    class="market_poster_dialog"
  >
    <div class="market_poster_body">
      <div class="left_panel">
        <el-form label-width="52px" class="poster_form">
          <el-form-item label="标题">
            <el-input v-model="form.title" placeholder="请输入标题" clearable />
          </el-form-item>
          <el-form-item label="内容" class="content_item">
            <el-input
              v-model="form.content"
              type="textarea"
              :rows="14"
              resize="none"
              placeholder="请输入内容"
            />
          </el-form-item>
        </el-form>

        <div class="left_actions">
          <el-button type="primary" class="btn_send" @click="handleSend">
            立即发送
          </el-button>
        </div>
      </div>

      <div class="right_panel">
        <div class="history_header">历史记录</div>

        <el-empty
          v-if="!historyToShow.length"
          description="暂无历史记录"
          class="history_empty"
        />

        <div v-else v-loading="historyLoading" class="history_viewport">
          <div
            v-for="item in historyToShow"
            :key="item.id ?? `${item.title}_${item.createtime ?? ''}`"
            class="history_card"
          >
            <div class="history_title">
              {{ item.title || "-" }}
            </div>
            <div class="history_content">
              {{ item.content || "-" }}
            </div>
            <div class="history_publisher">
              发布时间：{{ item.createtime_text || "-" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { computed, reactive, ref, watch } from "vue";
import { ElMessage } from "element-plus";
import request from "@/utils/request";

const props = defineProps({
  isMarketPoster: {
    type: Boolean,
    default: false,
  },
  circleId: {
    type: [Number, String],
    default: null,
  },
});

// 弹窗是否显示
const dialogVisible = computed({
  get: () => props.isMarketPoster,
  set: (value) => emit("update:isMarketPoster", value),
});

// 弹窗关闭事件
const emit = defineEmits(["update:isMarketPoster", "send"]);

const form = reactive({
  title: "",
  content: "",
});
const historyLoading = ref(false);
const historyList = ref([]);
const historyToShow = computed(() => historyList.value || []);

// 获取历史记录
const fetchHistoryList = async () => {
  historyLoading.value = true;
  try {
    const res = await request.post(
      "/teacher/market_info/lists",
      {
        teacher_id: props.circleId,
      }
    );
    const rawList = res?.data || [];
    historyList.value = Array.isArray(rawList)? rawList: [];
  } catch (e) {
    historyList.value = [];
  } finally {
    historyLoading.value = false;
  }
};

watch(
  () => dialogVisible.value,
  async (val) => {
    if (val) {
      // 初始化历史记录
      historyList.value = [];
      form.title = "";
      form.content = "";
      await fetchHistoryList();
    }
  }
);

// 发送海报
const handleSend = () => {
  const title = (form.title || "").trim();
  const content = (form.content || "").trim();

  if (!title) {
    ElMessage.warning("请输入标题");
    return;
  }
  if (!content) {
    ElMessage.warning("请输入内容");
    return;
  }
  request.post("/teacher/market_info/add",
    {
      teacher_id: props.circleId,
      title,
      content,
    }
  ).then(() => {
    ElMessage.success("发送成功");
    fetchHistoryList();
    // 清空表单数据
    form.title = "";
    form.content = "";
  });
};
</script>
<style scoped>
.market_poster_body {
  display: flex;
  gap: 16px;
  box-sizing: border-box;
  padding: 6px 0;
}

.left_panel {
  flex: 0 0 380px;
  box-sizing: border-box;
  padding: 16px 14px 12px;
  min-height: 560px;
  display: flex;
  flex-direction: column;
}

.content_item :deep(.el-form-item__content) {
  align-items: stretch;
}

.left_actions {
  display: flex;
  justify-content: flex-end;
}

.btn_send {
  width: 120px;
}

.right_panel {
  flex: 1;
  min-height: 560px;
}

.history_header {
  font-weight: 600;
  text-align: center;
  margin-bottom: 10px;
}

.history_empty {
  height: 520px;
}

.history_viewport {
  height: 520px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 12px;
}

.history_card {
  border: 2px solid #bdbaba;
  box-sizing: border-box;
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 10px;
}

.history_title {
  font-weight: 600;
  margin-bottom: 6px;
}

.history_content {
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 6px;
}

.history_publisher {
  color: #666;
  font-size: 12px;
  text-align: right;
}
</style>
